import * as type from "../../types";

export function fetchAdminAllLeads(page=1) {
  return {
    type: type.FETCH_ADMIN_ALL_LEADS,
    payload: { page },
  };
}
export function fetchGraphData() {
  return {
    type: type.FETCH_GRAPH,
  };
}
